import React from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router} from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import { Provider } from 'react-redux';
import 'bootstrap/dist/css/bootstrap.min.css';

//import './index.css';
import store from './store/store';
import App from './components/App'

ReactDOM.render(
// render(
    <Provider store={store}>
         <Router> 
             <App/> 
        </Router> 
    </Provider>,
document.getElementById('root')
);

serviceWorker.unregister();
